<div class="liberro-tabs" [ngClass]="{'liberro-tabs--switch-colors': switchColors}">
  <div
    class="tabs-header"
    [ngClass]="{
      'tabs-header--centered-desktop': centerDesktopTabs,
      'tabs-header--centered': centerTabs,
    }"
    [ngStyle]="{'max-width': headerMaxWidth}"
  >
    @for (tab of tabs(); track $index) {
      <button
        class="tab-item"
        [ngClass]="{ 'tab-item--large': largeTabsStyle }"
        [class.active]="isTabActive($index)"
        (click)="selectTab($index)"
        [attr.data-cy]="tab.dataCy || 'tab-' + $index"
      >
        @if(tab.liberroIconSrc()) {
          <svg-icon [src]="tab.liberroIconSrc()" class="tab-item-icon"></svg-icon>
        }
        {{ tab.label }}
      </button>
    }
    <ng-content></ng-content>
  </div>
  @if(!hideDivider) {
    <div class="tabs-divider"></div>
  }
  <div class="tabs-content" [ngClass]="{ 'tabs-content--no-padding': !tabsContentPadding }">
    @for (tab of tabs(); track $index) {
      @if (isTabActive($index)) {
        <div class="tab-content">
          <ng-container *ngTemplateOutlet="tab.template"></ng-container>
        </div>
      }
    }
  </div>
</div>
